export * from "./occlusionMaterial.pure";

import "../../Shaders/color.fragment";
import "../../Shaders/color.vertex";
